import { appConfig } from "@/app/app-config";
import { api as coreApi, initSwitchCore } from "@/core_bridge/switch-core/index";

let core_bootstrapped = false;

export async function bootCore(): Promise<void> {
  if (core_bootstrapped) return;
  core_bootstrapped = true;

  await initSwitchCore();
  if (coreApi?.configure) {
    coreApi.configure(appConfig.apiUrl, undefined);
  }

  console.log("[bootstrap/core] core initialized");
}
